// graphql-ws calls a non-CloseEvent problem fatal, so a Wi-Fi change killed every
// subscription. It checks its own fatal codes (4400, 4401, 4500) first, so true is safe.
export function shouldRetrySocket(_errOrCloseEvent: unknown): boolean {
  return true;
}

// The library default is an uncapped `2 ** retries` seconds.
export const MAX_RETRY_WAIT_MS = 30_000;
const JITTER_MIN_MS = 300;
const JITTER_MAX_MS = 3_000;

export function socketRetryWait(retries: number): Promise<void> {
  const jitterMs = Math.floor(Math.random() * (JITTER_MAX_MS - JITTER_MIN_MS) + JITTER_MIN_MS);
  const waitMs = Math.min(2 ** retries * 1_000 + jitterMs, MAX_RETRY_WAIT_MS);
  return new Promise(resolve => setTimeout(resolve, waitMs));
}
